import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import logo from "../../assets/images/logo.png";
import background from "../../assets/images/background.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import '../../styles/swiper-custom.css';
import { courseService } from '../../services/courseService';
import { documentService } from '../../services/documentService';
import '@fontsource/poppins/300.css'; // Light
import '@fontsource/poppins/400.css'; // Regular
import '@fontsource/poppins/500.css'; // Medium 
import '@fontsource/poppins/600.css'; // Semi-bold
import '@fontsource/poppins/700.css'; // Bold
import review1 from '../../assets/images/reviews/review1.png';
import review2 from '../../assets/images/reviews/review2.png';
import review3 from '../../assets/images/reviews/review3.png';
import review4 from '../../assets/images/reviews/review4.png';
import review5 from '../../assets/images/reviews/review5.png';
import review6 from '../../assets/images/reviews/review6.png';
import review7 from '../../assets/images/reviews/review7.png';
import review8 from '../../assets/images/reviews/review8.png';
import review9 from '../../assets/images/reviews/review9.png';
import review10 from '../../assets/images/reviews/review10.png';
import review11 from '../../assets/images/reviews/review11.png';
import review12 from '../../assets/images/reviews/review12.png';
import review13 from '../../assets/images/reviews/review13.png';
import review14 from '../../assets/images/reviews/review14.png';
import review15 from '../../assets/images/reviews/review15.png';
import review16 from '../../assets/images/reviews/review16.png';
import review17 from '../../assets/images/reviews/review17.png';
import review18 from '../../assets/images/reviews/review18.png';
import review19 from '../../assets/images/reviews/review19.png';
import review20 from '../../assets/images/reviews/review20.png';
import review21 from '../../assets/images/reviews/review21.png';
import review22 from '../../assets/images/reviews/review22.png';
import review23 from '../../assets/images/reviews/review23.png';
import review24 from '../../assets/images/reviews/review24.png';
import review25 from '../../assets/images/reviews/review25.png';
import review26 from '../../assets/images/reviews/review26.png';
import review27 from '../../assets/images/reviews/review27.png';
import review28 from '../../assets/images/reviews/review28.png';
import review29 from '../../assets/images/reviews/review29.png';
import review30 from '../../assets/images/reviews/review30.png';
import review31 from '../../assets/images/reviews/review31.png';
import review32 from '../../assets/images/reviews/review32.png';
import review33 from '../../assets/images/reviews/review33.png';
import review34 from '../../assets/images/reviews/review34.png';
import review35 from '../../assets/images/reviews/review35.png';
import review36 from '../../assets/images/reviews/review36.png';
import review37 from '../../assets/images/reviews/review37.png';
import ReactPlayer from 'react-player';

const stats = [
    {
        icon: (
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z" fill="currentColor" />
            </svg>
        ),
        number: "5000+",
        label: "Học viên",
        color: "text-black"
    },
    {
        icon: (
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z" fill="currentColor" />
                <path d="M17.5 10.5C18.38 10.5 19.23 10.59 20 10.76V9.24C19.21 9.09 18.36 9 17.5 9C15.8 9 14.26 9.29 13 9.83V11.49C14.13 10.85 15.7 10.5 17.5 10.5Z" fill="currentColor" />
                <path d="M13 12.49V14.15C14.13 13.51 15.7 13.16 17.5 13.16C18.38 13.16 19.23 13.25 20 13.42V11.9C19.21 11.75 18.36 11.66 17.5 11.66C15.8 11.66 14.26 11.96 13 12.49Z" fill="currentColor" />
                <path d="M17.5 14.33C15.8 14.33 14.26 14.63 13 15.16V16.82C14.13 16.18 15.7 15.83 17.5 15.83C18.38 15.83 19.23 15.92 20 16.09V14.57C19.21 14.41 18.36 14.33 17.5 14.33Z" fill="currentColor" />
            </svg>
        ),
        number: "5+",
        label: "Khóa học",
        color: "text-black"
    },
    {
        icon: (
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z" fill="currentColor" />
            </svg>
        ),
        number: "3+",
        label: "Năm kinh nghiệm",
        color: "text-black"
    },
    {
        icon: (
            <svg className="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z" fill="currentColor" />
            </svg>
        ),
        number: "90%",
        label: "Tỷ lệ thi đạt",
        color: "text-black"
    }
]

const reviewImages = [
    review1, review2, review3, review4, review5, review6, review7, review8, review9, review10,
    review11, review12, review13, review14, review15, review16, review17, review18, review19, review20,
    review21, review22, review23, review24, review25, review26, review27, review28, review29, review30,
    review31, review32, review33, review34, review35, review36, review37
];

const courseData = [
    {
        name: "IELTS Academic",
        description: "Khóa học IELTS Academic chuẩn bị cho kỳ thi quốc tế với phương pháp học hiệu quả",
        price: "4,500,000đ",
        imageLink: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
        name: "TOEIC Listening & Reading",
        description: "Luyện thi TOEIC L&R từ cơ bản đến nâng cao với giáo trình chuẩn quốc tế",
        price: "3,800,000đ",
        imageLink: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
        name: "Business English",
        description: "Tiếng Anh thương mại cho người đi làm, tập trung vào kỹ năng giao tiếp trong môi trường doanh nghiệp",
        price: "5,200,000đ",
        imageLink: "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    }
];

const documentData = [
    {
        name: "English Communication",
        description: "Phát triển kỹ năng giao tiếp tiếng Anh tự tin trong mọi tình huống",
        price: "3,500,000đ",
        imageLink: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
        name: "IELTS Foundation",
        description: "Khóa học nền tảng cho người mới bắt đầu IELTS, xây dựng căn bản vững chắc",
        price: "4,000,000đ",
        imageLink: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
        name: "English Grammar",
        description: "Ngữ pháp tiếng Anh từ cơ bản đến nâng cao với phương pháp học dễ nhớ",
        price: "3,200,000đ",
        imageLink: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    }
];

// Thêm mảng dữ liệu video demo
const demoVideos = [
    {
        title: "Giới thiệu Hien Le Aptis Website",
        description: "Tổng quan về mẫu tài liệu và giao diện ôn tập 4 kỹ năng",
        url: "https://www.youtube.com/watch?v=gVDqBjsH4j0"
    },
    {
        title: "Bài giảng mẫu Aptis Writing Part1",
        description: "Hướng dẫn chi tiết cách trả lời phần thi Writing Part 1",
        url: "https://www.youtube.com/watch?v=A5Yz7WshtsI"
    }
];

export default function Introduction() {
    const [courses, setCourses] = useState<any[]>([]);
    const [documents, setDocuments] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await courseService.getCourses({
                    page: 1,
                    pageSize: 100
                });
                if (response?.data) {
                    setCourses(response?.data);
                } else {
                    setCourses(courseData);
                }
            } catch (error) {
                // message.error('Không thể tải chính sách');
                setCourses(courseData);
            }
        };

        const fetchDocuments = async () => {
            try {
                const response = await documentService.getDocuments({
                    page: 1,
                    pageSize: 100
                });
                if (response?.data) {
                    setDocuments(response?.data);
                } else {
                    setDocuments(documentData);
                }
            } catch (error) {
                // message.error('Không thể tải chính sách');
                setDocuments(documentData);
            }
        };
        fetchCourses();
        fetchDocuments();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="min-h-screen flex flex-col introduction-page">
            {/* Top Bar - improved responsive design */}
            <div className="bg-[#192f59] text-[#96a2b8] py-2 md:py-4">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
                        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
                            <a href="mailto:aptisrealtests@gmail.com" className="text-xs md:text-sm hover:text-orange-400 transition-colors flex items-center">
                                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <span className='text-[13px] md:text-[15px] leading-6 font-normal'>aptisrealtests@gmail.com</span>
                            </a>
                            <a href="tel:0523413488" className="text-xs md:text-sm hover:text-orange-400 transition-colors flex items-center">
                                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                </svg>
                                <span className='text-[13px] md:text-[15px] leading-6 font-normal'>0523413488</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navigation - improved responsive design */}
            <div className="bg-white shadow-lg sticky top-0 z-50">
                <div className="container mx-auto px-4">
                    <div className="flex items-center justify-between py-2 md:py-4">
                        <div className="flex items-center space-x-2 md:space-x-4">
                            <img src={logo} alt="Logo" className="w-12 h-12 md:w-20 md:h-20" />
                            <span className="text-[#1B2A4E]">
                                <div>
                                    <p className='logo-text'>
                                        <span className='logo-text-name text-base md:text-2xl'>Hien Le</span>
                                        <span className='logo-text-aptis text-base md:text-2xl'>Aptis</span>
                                    </p>
                                    <p className="text-sm md:text-base">Aptis Real Tests</p>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hero Section - improved responsive design */}
            <section
                className="relative h-[400px] md:h-[800px] bg-cover bg-center"
                style={{ backgroundImage: `url(${background})` }}
            >
                <div className="absolute inset-0 flex items-center">
                    <div className="container mx-auto px-4">
                        <div className="max-w-xl animate-fade-in-up">
                            <p className="text-base sm:text-xl md:text-[33px] text-white font-[300] leading-normal mb-2 sm:mb-4 md:mb-8">
                                The Key To Your Future
                            </p>
                            <div className="hero-text inline-block text-white bg-[#18243be6] px-2 sm:px-3 md:px-4 mb-4 md:mb-8">
                                <div className="flex flex-row items-center justify-center">
                                    <span className="hero-text-name text-[32px] xs:text-2xl sm:text-4xl md:text-[88px] py-6">
                                        Hien Le
                                    </span>
                                    <span className="hero-text-aptis text-[32px] xs:text-2xl sm:text-4xl md:text-[88px]">
                                        Aptis
                                    </span>
                                </div>
                            </div>
                            <div className="flex space-x-4">
                                <Button
                                    type="primary"
                                    size="large"
                                    className="!bg-white !text-[#1B2A4E] hover:!text-[#1B2A4E] border-l-4 border-t-0 border-b-0 !border-l-[#51be78] rounded-none
                                    text-xs sm:text-sm md:text-base py-2 sm:py-3 md:py-6 px-4 sm:px-6 md:px-8 font-semibold"
                                >
                                    Register Now
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section - improved responsive design */}
            <section className="bg-white py-4 md:py-6">
                <div className="container mx-auto px-4 md:px-32">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-0">
                        {stats.map((stat, index) => (
                            <div
                                key={index}
                                className="flex flex-row items-center text-center"
                            >
                                <div className={`p-1 md:p-2 ${stat.color}`}>
                                    {React.cloneElement(stat.icon as React.ReactElement<any>, {
                                        className: 'w-8 h-8 md:w-12 md:h-12'
                                    })}
                                </div>
                                <div className='p-1 md:p-2 flex flex-col items-start align-center'>
                                    <div className="font-semibold text-lg md:text-xl text-[#1B2A4E] mb-1 md:mb-2">
                                        {stat.number}
                                    </div>
                                    <p className="text-gray-400 text-sm md:text-base text-start">
                                        {stat.label}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Documents Section */}
            <section className="bg-gray-50 py-10">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-8">
                        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4E] mb-4">
                            Bộ tài liệu Aptis Esol General
                        </h2>
                        <div className="w-24 h-1 bg-[#1B2A4E] mx-auto mb-6"></div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
                        {courses.map((course, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-2xl transition-all duration-300">
                                <div className="relative h-40 sm:h-48 overflow-hidden">
                                    <img
                                        src={course?.imageLink}
                                        alt={course?.name}
                                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-4 sm:p-6 bg-[#1B2A4E] text-white h-full flex flex-col">
                                    <div>
                                        <h3 className="text-lg sm:text-xl mb-2 transition-colors line-clamp-1">
                                            {course?.name}
                                        </h3>

                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: course?.description?.replace(/\n/g, '<br />') || ''
                                            }}
                                            className="text-xs sm:text-sm text-gray-300 mb-3 sm:mb-4">
                                        </p>
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        <span className="text-lg sm:text-2xl text-orange-500 font-bold">
                                            {course?.price?.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}
                                        </span>
                                        <div className="flex gap-2">
                                            <Button
                                                type="primary"
                                                className="flex-1 bg-white text-[#1B2A4E] hover:!bg-orange-500 border-none text-xs sm:text-sm h-8 sm:h-auto flex items-center justify-center gap-1"
                                                href="https://www.facebook.com/hienleaptis/"
                                                target="_blank"
                                            >
                                                <svg
                                                    className="w-4 h-4"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                >
                                                    <path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.909.252 1.871.388 2.869.388 5.523 0 10-4.145 10-9.259C22 6.146 17.523 2 12 2zm1.008 12.461l-2.549-2.719-4.968 2.719 5.467-5.821 2.61 2.719 4.907-2.719-5.467 5.821z" />
                                                </svg>
                                                <span>Messenger</span>
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="flex-1 bg-white text-[#1B2A4E] hover:!bg-orange-500 border-none text-xs sm:text-sm h-8 sm:h-auto flex items-center justify-center gap-1"
                                                href="https://zalo.me/0523413488"
                                                target="_blank"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 50 50">
                                                    <path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 15.580078 6 C 12.00899 9.7156859 10 14.518083 10 19.5 C 10 24.66 12.110156 29.599844 15.910156 33.339844 C 16.030156 33.549844 16.129922 34.579531 15.669922 35.769531 C 15.379922 36.519531 14.799687 37.499141 13.679688 37.869141 C 13.249688 38.009141 12.97 38.430859 13 38.880859 C 13.03 39.330859 13.360781 39.710781 13.800781 39.800781 C 16.670781 40.370781 18.529297 39.510078 20.029297 38.830078 C 21.379297 38.210078 22.270625 37.789609 23.640625 38.349609 C 26.440625 39.439609 29.42 40 32.5 40 C 36.593685 40 40.531459 39.000731 44 37.113281 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 33 15 C 33.55 15 34 15.45 34 16 L 34 25 C 34 25.55 33.55 26 33 26 C 32.45 26 32 25.55 32 25 L 32 16 C 32 15.45 32.45 15 33 15 z M 18 16 L 23 16 C 23.36 16 23.700859 16.199531 23.880859 16.519531 C 24.050859 16.829531 24.039609 17.219297 23.849609 17.529297 L 19.800781 24 L 23 24 C 23.55 24 24 24.45 24 25 C 24 25.55 23.55 26 23 26 L 18 26 C 17.64 26 17.299141 25.800469 17.119141 25.480469 C 16.949141 25.170469 16.960391 24.780703 17.150391 24.470703 L 21.199219 18 L 18 18 C 17.45 18 17 17.55 17 17 C 17 16.45 17.45 16 18 16 z M 27.5 19 C 28.11 19 28.679453 19.169219 29.189453 19.449219 C 29.369453 19.189219 29.65 19 30 19 C 30.55 19 31 19.45 31 20 L 31 25 C 31 25.55 30.55 26 30 26 C 29.65 26 29.369453 25.810781 29.189453 25.550781 C 28.679453 25.830781 28.11 26 27.5 26 C 25.57 26 24 24.43 24 22.5 C 24 20.57 25.57 19 27.5 19 z M 38.5 19 C 40.43 19 42 20.57 42 22.5 C 42 24.43 40.43 26 38.5 26 C 36.57 26 35 24.43 35 22.5 C 35 20.57 36.57 19 38.5 19 z M 27.5 21 C 27.39625 21 27.29502 21.011309 27.197266 21.03125 C 27.001758 21.071133 26.819727 21.148164 26.660156 21.255859 C 26.500586 21.363555 26.363555 21.500586 26.255859 21.660156 C 26.148164 21.819727 26.071133 22.001758 26.03125 22.197266 C 26.011309 22.29502 26 22.39625 26 22.5 C 26 22.60375 26.011309 22.70498 26.03125 22.802734 C 26.051191 22.900488 26.079297 22.994219 26.117188 23.083984 C 26.155078 23.17375 26.202012 23.260059 26.255859 23.339844 C 26.309707 23.419629 26.371641 23.492734 26.439453 23.560547 C 26.507266 23.628359 26.580371 23.690293 26.660156 23.744141 C 26.819727 23.851836 27.001758 23.928867 27.197266 23.96875 C 27.29502 23.988691 27.39625 24 27.5 24 C 27.60375 24 27.70498 23.988691 27.802734 23.96875 C 28.487012 23.82916 29 23.22625 29 22.5 C 29 21.67 28.33 21 27.5 21 z M 38.5 21 C 38.39625 21 38.29502 21.011309 38.197266 21.03125 C 38.099512 21.051191 38.005781 21.079297 37.916016 21.117188 C 37.82625 21.155078 37.739941 21.202012 37.660156 21.255859 C 37.580371 21.309707 37.507266 21.371641 37.439453 21.439453 C 37.303828 21.575078 37.192969 21.736484 37.117188 21.916016 C 37.079297 22.005781 37.051191 22.099512 37.03125 22.197266 C 37.011309 22.29502 37 22.39625 37 22.5 C 37 22.60375 37.011309 22.70498 37.03125 22.802734 C 37.051191 22.900488 37.079297 22.994219 37.117188 23.083984 C 37.155078 23.17375 37.202012 23.260059 37.255859 23.339844 C 37.309707 23.419629 37.371641 23.492734 37.439453 23.560547 C 37.507266 23.628359 37.580371 23.690293 37.660156 23.744141 C 37.739941 23.797988 37.82625 23.844922 37.916016 23.882812 C 38.005781 23.920703 38.099512 23.948809 38.197266 23.96875 C 38.29502 23.988691 38.39625 24 38.5 24 C 38.60375 24 38.70498 23.988691 38.802734 23.96875 C 39.487012 23.82916 40 23.22625 40 22.5 C 40 21.67 39.33 21 38.5 21 z"></path>
                                                </svg>
                                                <span>Zalo</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Courses Section */}
            <section className="bg-gray-50 py-10">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-8">
                        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4E] mb-4">
                            Khóa học Aptis Esol General
                        </h2>
                        <div className="w-24 h-1 bg-[#1B2A4E] mx-auto mb-6"></div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
                        {documents.map((course, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-2xl transition-all duration-300">
                                <div className="relative h-40 sm:h-48 overflow-hidden">
                                    <img
                                        src={course?.imageLink}
                                        alt={course?.name}
                                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-4 sm:p-6 bg-[#1B2A4E] text-white h-full flex flex-col">
                                    <div>
                                        <h3 className="text-lg sm:text-xl mb-2 transition-colors">
                                            {course?.name}
                                        </h3>

                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: course?.description?.replace(/\n/g, '<br />') || ''
                                            }}
                                            className="text-xs sm:text-sm text-gray-300 mb-3 sm:mb-4 "
                                        ></p>
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        <span className="text-lg sm:text-2xl text-orange-500 font-bold">
                                            {course?.price?.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}
                                        </span>
                                        <div className="flex gap-2">
                                            <Button
                                                type="primary"
                                                className="flex-1 bg-white text-[#1B2A4E] hover:!bg-orange-500 border-none text-xs sm:text-sm h-8 sm:h-auto flex items-center justify-center gap-1"
                                                href="https://www.facebook.com/hienleaptis/"
                                                target="_blank"
                                            >
                                                <svg
                                                    className="w-4 h-4"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                >
                                                    <path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.909.252 1.871.388 2.869.388 5.523 0 10-4.145 10-9.259C22 6.146 17.523 2 12 2zm1.008 12.461l-2.549-2.719-4.968 2.719 5.467-5.821 2.61 2.719 4.907-2.719-5.467 5.821z" />
                                                </svg>
                                                <span>Messenger</span>
                                            </Button>
                                            <Button
                                                type="primary"
                                                className="flex-1 bg-white text-[#1B2A4E] hover:!bg-orange-500 border-none text-xs sm:text-sm h-8 sm:h-auto flex items-center justify-center gap-1"
                                                href="https://zalo.me/0523413488"
                                                target="_blank"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 50 50">
                                                    <path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 15.580078 6 C 12.00899 9.7156859 10 14.518083 10 19.5 C 10 24.66 12.110156 29.599844 15.910156 33.339844 C 16.030156 33.549844 16.129922 34.579531 15.669922 35.769531 C 15.379922 36.519531 14.799687 37.499141 13.679688 37.869141 C 13.249688 38.009141 12.97 38.430859 13 38.880859 C 13.03 39.330859 13.360781 39.710781 13.800781 39.800781 C 16.670781 40.370781 18.529297 39.510078 20.029297 38.830078 C 21.379297 38.210078 22.270625 37.789609 23.640625 38.349609 C 26.440625 39.439609 29.42 40 32.5 40 C 36.593685 40 40.531459 39.000731 44 37.113281 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 33 15 C 33.55 15 34 15.45 34 16 L 34 25 C 34 25.55 33.55 26 33 26 C 32.45 26 32 25.55 32 25 L 32 16 C 32 15.45 32.45 15 33 15 z M 18 16 L 23 16 C 23.36 16 23.700859 16.199531 23.880859 16.519531 C 24.050859 16.829531 24.039609 17.219297 23.849609 17.529297 L 19.800781 24 L 23 24 C 23.55 24 24 24.45 24 25 C 24 25.55 23.55 26 23 26 L 18 26 C 17.64 26 17.299141 25.800469 17.119141 25.480469 C 16.949141 25.170469 16.960391 24.780703 17.150391 24.470703 L 21.199219 18 L 18 18 C 17.45 18 17 17.55 17 17 C 17 16.45 17.45 16 18 16 z M 27.5 19 C 28.11 19 28.679453 19.169219 29.189453 19.449219 C 29.369453 19.189219 29.65 19 30 19 C 30.55 19 31 19.45 31 20 L 31 25 C 31 25.55 30.55 26 30 26 C 29.65 26 29.369453 25.810781 29.189453 25.550781 C 28.679453 25.830781 28.11 26 27.5 26 C 25.57 26 24 24.43 24 22.5 C 24 20.57 25.57 19 27.5 19 z M 38.5 19 C 40.43 19 42 20.57 42 22.5 C 42 24.43 40.43 26 38.5 26 C 36.57 26 35 24.43 35 22.5 C 35 20.57 36.57 19 38.5 19 z M 27.5 21 C 27.39625 21 27.29502 21.011309 27.197266 21.03125 C 27.001758 21.071133 26.819727 21.148164 26.660156 21.255859 C 26.500586 21.363555 26.363555 21.500586 26.255859 21.660156 C 26.148164 21.819727 26.071133 22.001758 26.03125 22.197266 C 26.011309 22.29502 26 22.39625 26 22.5 C 26 22.60375 26.011309 22.70498 26.03125 22.802734 C 26.051191 22.900488 26.079297 22.994219 26.117188 23.083984 C 26.155078 23.17375 26.202012 23.260059 26.255859 23.339844 C 26.309707 23.419629 26.371641 23.492734 26.439453 23.560547 C 26.507266 23.628359 26.580371 23.690293 26.660156 23.744141 C 26.819727 23.851836 27.001758 23.928867 27.197266 23.96875 C 27.29502 23.988691 27.39625 24 27.5 24 C 27.60375 24 27.70498 23.988691 27.802734 23.96875 C 28.487012 23.82916 29 23.22625 29 22.5 C 29 21.67 28.33 21 27.5 21 z M 38.5 21 C 38.39625 21 38.29502 21.011309 38.197266 21.03125 C 38.099512 21.051191 38.005781 21.079297 37.916016 21.117188 C 37.82625 21.155078 37.739941 21.202012 37.660156 21.255859 C 37.580371 21.309707 37.507266 21.371641 37.439453 21.439453 C 37.303828 21.575078 37.192969 21.736484 37.117188 21.916016 C 37.079297 22.005781 37.051191 22.099512 37.03125 22.197266 C 37.011309 22.29502 37 22.39625 37 22.5 C 37 22.60375 37.011309 22.70498 37.03125 22.802734 C 37.051191 22.900488 37.079297 22.994219 37.117188 23.083984 C 37.155078 23.17375 37.202012 23.260059 37.255859 23.339844 C 37.309707 23.419629 37.371641 23.492734 37.439453 23.560547 C 37.507266 23.628359 37.580371 23.690293 37.660156 23.744141 C 37.739941 23.797988 37.82625 23.844922 37.916016 23.882812 C 38.005781 23.920703 38.099512 23.948809 38.197266 23.96875 C 38.29502 23.988691 38.39625 24 38.5 24 C 38.60375 24 38.70498 23.988691 38.802734 23.96875 C 39.487012 23.82916 40 23.22625 40 22.5 C 40 21.67 39.33 21 38.5 21 z"></path>
                                                </svg>
                                                <span>Zalo</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Demo Videos Section - Updated with ReactPlayer */}
            <section className="bg-gray-50 py-20">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-[#1B2A4E] mb-4">
                            Học thử cùng chúng tôi
                        </h2>
                        <div className="w-24 h-1 bg-[#1B2A4E] mx-auto mb-6"></div>
                        <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                            Trải nghiệm bộ Key Aptis và khóa học chất lượng từ đội ngũ giảng viên của chúng tôi
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
                        {demoVideos.map((video, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                                <div className="aspect-video relative">
                                    <ReactPlayer
                                        url={video.url}
                                        width="100%"
                                        height="100%"
                                        controls={true}
                                        pip={false} // Hỗ trợ picture-in-picture
                                        stopOnUnmount={false} // Không dừng video khi component unmount
                                        className="absolute top-0 left-0"
                                        config={{
                                            youtube: {
                                                playerVars: {
                                                    modestbranding: 1,
                                                    rel: 0
                                                }
                                            }
                                        }}
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-semibold text-[#1B2A4E] mb-2">
                                        {video.title}
                                    </h3>
                                    <p className="text-gray-600 text-sm">
                                        {video.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            <section className="bg-gradient-to-b from-white to-gray-50 py-20">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-[#1B2A4E] mb-4">
                            Học viên nói gì về chúng tôi?
                        </h2>
                        <div className="w-24 h-1 bg-[#1B2A4E] mx-auto mb-6"></div>
                        <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                            Những phản hồi chân thực từ các học viên đã tham gia khóa học
                        </p>
                    </div>

                    <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={30}
                        slidesPerView={1}
                        pagination={{
                            clickable: true,
                            bulletActiveClass: 'swiper-pagination-bullet-active',
                            bulletClass: 'swiper-pagination-bullet',
                            horizontalClass: 'swiper-pagination-horizontal'
                        }}
                        autoplay={{
                            delay: isMobile ? 5000 : 10000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                        }}
                        className="testimonials-slider !pb-16"
                    >
                        {reviewImages.map((image, index) => (
                            <SwiperSlide key={index}>
                                <div className="bg-white rounded-xl shadow-lg hover:shadow-xl 
                                transition-shadow duration-300 overflow-hidden aspect-[3/4] max-w-[350px] mx-auto">
                                    <img
                                        src={image}
                                        alt={`Review ${index + 1}`}
                                        className="w-full h-full object-contain p-3"
                                        loading="lazy"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            {/* Footer Section */}
            <footer className="bg-[#1B2A4E] text-white py-8 sm:py-12 lg:py-16">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
                        {/* Brand & Description */}
                        <div className="space-y-4 sm:space-y-6 col-span-1 md:col-span-2">
                            <div className="flex items-center">
                                <img src={logo} alt="Logo" className="w-12 h-12 sm:w-16 sm:h-16" />
                                <div className="ml-3 sm:ml-4">
                                    <span className="text-xl sm:text-2xl font-bold text-white block">Hien Le Aptis</span>
                                    <span className="text-xs sm:text-sm text-gray-400">The Key To Your Future</span>
                                </div>
                            </div>
                            <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-xl">
                                Chúng tôi cung cấp các Khóa học Aptis cam kết đầu ra và Bộ tài liệu tự ôn Aptis chất lượng cao,
                                giúp học viên đạt được mục tiêu trong học tập và sự nghiệp.
                            </p>
                            <div className="flex space-x-3 sm:space-x-4">
                                <a
                                    href="https://www.facebook.com/hienleaptis/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[#2C3E6F] flex items-center justify-center hover:bg-[#3B4F84] transition-colors duration-300"
                                >
                                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.04C6.477 2.04 2 6.145 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.909.252 1.871.388 2.869.388 5.523 0 10-4.145 10-9.259C22 6.146 17.523 2 12 2.04Z" />
                                    </svg>
                                </a>
                                <a
                                    href="https://zalo.me/0523413488"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Zalo"
                                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[#2C3E6F] flex items-center justify-center hover:bg-[#3B4F84] transition-colors duration-300"
                                >
                                    <span className="text-xs sm:text-sm font-bold">Zalo</span>
                                </a>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="mt-6 md:mt-0">
                            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 relative inline-block">
                                Thông tin liên hệ
                                <span className="absolute -bottom-2 left-0 w-12 h-1 bg-[#3B4F84]"></span>
                            </h3>
                            <ul className="space-y-3 sm:space-y-4">
                                <li className="flex items-start space-x-3 text-gray-400 hover:text-white transition-colors duration-300">
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                    </svg>
                                    <div>
                                        <p className="text-sm sm:text-base font-medium mb-1">Email</p>
                                        <a href="mailto:aptisrealtests@gmail.com" className="text-xs sm:text-sm hover:underline">
                                            aptisrealtests@gmail.com
                                        </a>
                                    </div>
                                </li>
                                <li className="flex items-start space-x-3 text-gray-400 hover:text-white transition-colors duration-300">
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.45-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99-.99z" />
                                    </svg>
                                    <div>
                                        <p className="text-sm sm:text-base font-medium mb-1">Điện thoại</p>
                                        <a href="tel:0523413488" className="text-xs sm:text-sm hover:underline">
                                            0523413488
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-[#2C3E6F] mt-8 sm:mt-12 pt-6 sm:pt-8">
                        <div className="flex justify-center">
                            <p className="text-xs sm:text-sm text-gray-400">
                                © {new Date().getFullYear()} Hien Le Aptis. All rights reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}